import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialogContent, MatDialogTitle, MatDialogActions, MatDialogClose } from "@angular/material/dialog";
import * as _ from 'lodash-es';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { RxReactiveFormsModule } from '@rxweb/reactive-form-validators';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';
import { TranslatePipe } from '@ngx-translate/core';


export interface InputDialogOptions {
    title: string;
    label: string;
    valid: string;
    defaultValue: any;
    placeholder?: string;
}

@Component({
    selector: 'app-input-dialog',
    templateUrl: './input-dialog.component.html',
    styleUrls: ['./input-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CdkScrollable, MatDialogContent, MatDialogTitle, FormsModule, ReactiveFormsModule, RxReactiveFormsModule, MatFormField, MatLabel, MatInput, MatDialogActions, MatButton, MatDialogClose, TranslatePipe]
})
export class InputDialog implements OnInit {
    protected fb = inject(FormBuilder);
    protected dialogRef = inject<MatDialogRef<InputDialog>>(MatDialogRef);
    config = inject<InputDialogOptions>(MAT_DIALOG_DATA);


    get controls(): { [x: string]: FormControl; } { return this.form.controls as { [x: string]: FormControl; }; }

    form: FormGroup;
    title: string = '';
    label: string = '';
    valid: string;
    placeholder: string;

    get isValid(): boolean { return this.form.valid; }

    constructor() {
        const fb = this.fb;
        const config = this.config;


        this.title = config.title || '';
        this.label = config.label || '';
        this.valid = config.valid || 'YES';
        this.placeholder = config.placeholder || '';
        this.form = fb.group({
            data: new FormControl(config.defaultValue || '', [Validators.required]),
        });
    }

    ngOnInit() { }

    submit(): void {
        this.dialogRef.close(_.cloneDeep(this.form.value));
    }

    close(): void {
        this.dialogRef.close();
    }
}
